module.exports = __webpack_public_path__ + "static/media/burger.13853547.svg";


//////////////////
// WEBPACK FOOTER
// ./src/resources/NavBar/burger.svg
// module id = 271
// module chunks = 0